export default "__VITE_ASSET__Z73pbVzu__"